(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/views/start.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/views/start.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.tickets_einstant=_svs.tickets_einstant||{};
_svs.tickets_einstant.templates=_svs.tickets_einstant.templates||{};
svs.tickets_einstant.templates.start = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"reactContainer\"></div>\n";
},"useData":true});
Handlebars.partials['svs-tickets_einstant-start'] = svs.tickets_einstant.templates.start;
})(svs, Handlebars);


 })(window);